import VillageContent from "../../components/VillageContent/VillageContent"
import NewPostForm from "../../components/NewPostForm/NewPostForm"

const VillageProfilePage = () => {

    return (
        <>
            <VillageContent />
            {/* <NewPostForm /> */}
        </>
    )
}

export default VillageProfilePage